import { getCompositionById } from '../api/canvases';
import { DockingWidgetInfo, VideoCompositionId } from '../types/obs';
import { promisefy } from './promisefy';

export function getVideoCompositionDockingWidgetId(params: { videoCompositionId: string }) {
  return `streamelements_selive_multistreaming_canvas_${params.videoCompositionId}`;
}

export function getVideoCompositionDockingWidgetTitle(params: { videoCompositionName: string }) {
  return `${params.videoCompositionName} - StreamElements Canvas`;
}

export async function openVideoCompositionDockingWidget({
  videoCompositionId,
}: {
  videoCompositionId: VideoCompositionId;
}) {
  if (videoCompositionId === 'default') {
    return {
      widgetId: 'default',
      widgetOnTheRightId: undefined,
    };
  }

  const widgetId = getVideoCompositionDockingWidgetId({ videoCompositionId });

  const dockingWidgets = await promisefy(window.host.getAllDockingWidgets)();
  const widget = dockingWidgets[widgetId];
  let widgetOnTheRight: DockingWidgetInfo | null = null;

  for (const value of Object.values(dockingWidgets)) {
    if (value.dockingArea === 'right' && value.id !== widgetId) {
      widgetOnTheRight = value;
      break;
    }
  }

  if (widget) {
    await promisefy(window.host.showDockingWidgetById)(widgetId);
    return {
      widgetId,
      widgetOnTheRightId: widgetOnTheRight?.id,
    };
  }

  const canvas = await getCompositionById(videoCompositionId);

  if (!canvas) {
    throw new Error('Failed to open canvas');
  }

  return promisefy(window.host.batchInvokeSeries)([
    {
      invoke: 'addDockingWidget',
      invokeArgs: [
        {
          id: widgetId,
          title: getVideoCompositionDockingWidgetTitle({ videoCompositionName: canvas.name }),
          url: new URL(`/canvases/${videoCompositionId}`, window.location.origin).toString(),
          dockingArea: 'floating',
          visible: true,
          minHeight: 470,
          minWidth: 250,
          width: 300,
          height: 800,
        },
      ],
    },
    {
      invoke: 'showDockingWidgetById',
      invokeArgs: [widgetId],
    },
  ]);
}
